import {PROVIDER_NAMES} from './constants'

/* Providers */
export const isVodafone = (providerName) => {
    return providerName === PROVIDER_NAMES.VODAFONE
}

export const isOdido = (providerName) => {
    return providerName === PROVIDER_NAMES.ODIDO
}

export const isKpn = (providerName) => {
    return providerName === PROVIDER_NAMES.KPN
}

export const isLebara = (providerName) => {
    return providerName === PROVIDER_NAMES.LEBARA
}

export const isHollandsnieuwe = (providerName) => {
    return providerName === PROVIDER_NAMES.HOLLANDSNIEUWE
}
/* Providers */
